import React, { Suspense, lazy, useEffect } from "react";
import { useLocation } from "react-router-dom";

import Hero from "../sections/Hero";
import { navSections } from "../data/profile";
import { startScrollDriver } from "../three/scrollStore";

/* Everything below the fold is split out. Hero + Nav is what the LCP
   depends on; the rest can arrive a tick later. */
const About = lazy(() => import("../sections/About"));
const Skills = lazy(() => import("../sections/Skills"));
const Experience = lazy(() => import("../sections/Experience"));
const Projects = lazy(() => import("../sections/Projects"));
const Education = lazy(() => import("../sections/Education"));
const Credentials = lazy(() => import("../sections/Credentials"));
const Faq = lazy(() => import("../sections/Faq"));
const Reviews = lazy(() => import("../sections/Reviews"));
const Contact = lazy(() => import("../sections/Contact"));

/** Reserves height while a chunk loads so the scroll position never jumps. */
function SectionSkeleton() {
  return <div aria-hidden="true" className="min-h-[60vh]" />;
}

export default function Home() {
  const location = useLocation();

  // One rAF loop owns scroll state for the whole page — the 3D scene, the
  // progress rail and the nav all read from it.
  useEffect(() => {
    const stop = startScrollDriver(navSections.map((s) => s.id));
    return stop;
  }, []);

  // Support /#section deep links arriving from another route.
  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.slice(1);
    const t = setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }, 260);
    return () => clearTimeout(t);
  }, [location.hash]);

  return (
    <main id="main">
      <Hero />

      <Suspense fallback={<SectionSkeleton />}>
        <About />
        <Skills />
        <Experience />
        <Projects />
        <Education />
        <Credentials />
        <Faq />
        <Reviews />
        <Contact />
      </Suspense>
    </main>
  );
}
